/**
 * Which approved MasterSidebar items are visible for a tenant kind.
 * Does not invent pages — only filters the existing shell.
 */

export function getSidebarVisibility(kind) {
  if (kind === "music-vendor") {
    return {
      brandManager: false,
      musicSection: true,
      channels: false,
      uploader: true,
      history: true,
      messagesSection: false,
      talentRequest: false,
      inProduction: false,
      messagingSchedule: false,
      manageSection: true,
      account: true,
      userManagement: true,
      locations: false,
      billing: false,
      support: false,
      faq: false,
    };
  }

  if (kind === "installer-vendor") {
    return {
      brandManager: false,
      musicSection: false,
      channels: false,
      uploader: false,
      history: false,
      messagesSection: false,
      talentRequest: false,
      inProduction: false,
      messagingSchedule: false,
      manageSection: true,
      account: true,
      userManagement: true,
      locations: false,
      billing: false,
      support: false,
      faq: false,
    };
  }

  // client (default): full approved shell minus Uploader + History
  return {
    brandManager: true,
    musicSection: true,
    channels: true,
    uploader: false,
    history: false,
    messagesSection: true,
    talentRequest: true,
    inProduction: true,
    messagingSchedule: true,
    manageSection: true,
    account: false,
    userManagement: true,
    locations: true,
    billing: true,
    support: true,
    faq: true,
  };
}
